import sanitize from 'sanitize-html';

export const allowedTags = [
  ...sanitize.defaults.allowedTags,
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'span',
  'img',
  'video',
  'source',
];

export const allowedAttributes = {
  ...sanitize.defaults.allowedAttributes,
  '*': ['class', 'style', 'width', 'height'],
  td: ['valign'],
  video: ['src', 'controls', 'preload'],
  source: ['src', 'type'],
};
